import { useState, useEffect } from "react"
import ButtonActivateNotification from "../components/componentsScreenNotifications/ButtonActivateNotification"
import ButtonLogout from "../components/componentsScreenSettings/ButtonLogout"
import {getDesktopToken} from '../services/userServices.js'
export default function Ajustes(){

    const [show, setShow] = useState(false)
    const [token, setToken] = useState('')

    useEffect(() => {
        const chechToken = async() => {
            const data = await getDesktopToken()
            console.log(data)
            setToken(data.token.desktopToken)
        }
        chechToken()
    }, [show])

    return(
        <div>
            <h1>Ajustes</h1>
            <h3>Perfil</h3>
            
            <ButtonLogout></ButtonLogout>
            <h3>Permisos</h3>
            <ButtonActivateNotification></ButtonActivateNotification>
            <view>
                <button onClick={() => setShow(!show)}>Mostrar Token device</button>
                {
                    show &&(
                        <p>{token}</p>
                    )
                }
            </view>
        </div>
    )
}